/* src/app/layout/sidebar/sidebar.component.scss */
/*# sourceMappingURL=sidebar.component-Q7DUQ7HF.css.map */
